import { dom } from "@omegagrid/core";
import { FormContainer } from "@omegagrid/form";
import rp, { SyncEditorAdapter, SyncEditorOptions, SyncTypes, SyncFormAdapter } from "@reporting/rp-app-host";
import { AccountingTreeAdapter } from "@reporting/rp-mf-accounting";
import { ObjectShare } from "@reporting/rp-types/core";
import { StatementDefinition } from "@reporting/rp-types/definition";


export class FinSyncEditorAdapter extends SyncEditorAdapter {

	async delete(idz: number) {
		await rp.ms('definition').delete(`sync/objects/${idz}`);
	}

	async getEditFormComponent(idz: number): Promise<HTMLElement> {
		const component = dom.createElement<FormContainer>('og-form-container');
		component.adapter = new SyncFormAdapter(
			rp.ms('definition'),
			[{
				key: 'id_object',
				getSourceData: async () => {
					const statements = await rp.ms('definition').get<StatementDefinition[]>('statements');
					return statements.map(s => ({ k: s.id_statement.toString(), v: s.statement }));
				},
			}, {
				key: 'accounting_share',
				// the statements are shared within the group: its companies but this one, as a tree
				getSourceData: () => new AccountingTreeAdapter({
					idGroup: rp.accountingProvider.accounting.id_accounting_group,
					excludedAccounting: rp.accountingProvider.a,
					byGroups: true,
				}).getTree(),
			}],
			idz
		);
		return component;
	}

	async getObjects(): Promise<ObjectShare[]> {
		const objects = await rp.ms('definition').get<ObjectShare[]>('sync/objects');
		return objects;
	}

	getOptions(): Partial<SyncEditorOptions> {
		return this.createOptions({
			syncType: SyncTypes.SHARE,
			listItemFields: ['company', 'date_created', 'who_created'],
			columns: ['name', 'company', 'date_created', 'who_created'],
			toolbar: {
				sync: { enabled: false },
			}
		});
	}

}
